import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BlobService} from '../../core/services/blob.service';
import {UserService} from "../../core/services/user.service";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
    selector: 'app-notices',
    templateUrl: './notices.component.html',
    styleUrls: ['./notices.component.scss'],
    standalone: false
})
export class NoticesComponent implements OnInit {

    public notices = [];
    @Input() noticeLocation: string;

    private ngUnsubscribe$ = new Subject<void>();
    private selectedIdf;
    private dc;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private blobService: BlobService,
        private userService: UserService,
    ) {

        this.userService.selectedIdf$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(current => {
            this.selectedIdf = current;
            if (this.selectedIdf && this.selectedIdf.distributionCenters) {
                this.dc = this.selectedIdf.distributionCenters[0].id;
            }
            this.getActiveNotices();
        });

    }

    ngOnInit(): void {
    }

    async getActiveNotices() {
        try {
            const allNotices = JSON.parse(<string>await this.blobService.getData('notices.json', 'marketing-management'));
            this.notices = allNotices.filter(
                notice => this.isNoticeVisible(notice) && this.matchesDistributionCenter(notice)
            );
        } catch (error) {
            console.error('Error fetching notices:', error);
            this.notices = [];
        }
    }

    showNotice(filter: string) {
        let route;
        if (this.noticeLocation !== 'login') {
            route = this.router.url.replace(/^\/|\/$/g, '');
        } else {
            route = this.activatedRoute.snapshot.routeConfig.path;
        }
        return !(filter !== null && filter !== route && !route.includes(filter));
    }

    private isNoticeVisible(notice: any): boolean {
        const now = new Date();

        if (!notice.start && !notice.end) {
            return true;
        }

        if (notice.start && !notice.end) {
            const startDate = new Date(notice.start);
            return now >= startDate;
        }

        if (notice.start && notice.end) {
            const startDate = new Date(notice.start);
            const endDate = new Date(notice.end);
            return now >= startDate && now <= endDate;
        }

        if (!notice.start && notice.end) {
            const endDate = new Date(notice.end);
            return now <= endDate;
        }

        return false;
    }

    private matchesDistributionCenter(notice: any): boolean {
        if (!notice.distributionCenters || notice.distributionCenters.length === 0) {
            return true;
        }
        if (this.dc == null) {
            return false;
        }
        return notice.distributionCenters.includes(this.dc);
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

}

